export var TRANSFER_HISTORY_DATA = "TRANSFER_HISTORY_DATA";
export var TRANSFER_HISTORY_PAYIN_START_LOADER = "TRANSFER_HISTORY_PAYIN_START_LOADER";
export var TRANSFER_HISTORY_PAYOUT_START_LOADER = "TRANSFER_HISTORY_PAYOUT_START_LOADER";
export var TRANSFER_HISTORY_PAYIN_STOP_LOADER = "TRANSFER_HISTORY_PAYIN_STOP_LOADER";
export var TRANSFER_HISTORY_PAYOUT_STOP_LOADER = "TRANSFER_HISTORY_PAYOUT_STOP_LOADER";
export var TRANSFER_HISTORY_HIDE_ERROR = "TRANSFER_HISTORY_HIDE_ERROR";
export var TRANSFER_HISTORY_ERROR = "TRANSFER_HISTORY_ERROR";
export var FILTER_HISTORY_DATA = "FILTER_HISTORY_DATA";
export var TRANSFER_HISTORY_FILTERS = "TRANSFER_HISTORY_FILTERS";
